import { useTranslation } from "react-i18next";
import TextField from "@/components/layouts/History/TextField";
import { useOnboardingStages } from "@/pages/settings/components/contractsSettings/hooks";

interface Props {
  value: string;
}

export const OnboardingStageName: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  const { data: stagesResponse, isLoading } = useOnboardingStages();
  const stage = stagesResponse?.stages.find(
    (onboardingStage) => onboardingStage.id === value
  );

  // An id that resolves to nothing (deleted stage) falls back the same way the
  // other lookup renderers do — but not while the lookup is still in flight, or
  // "unknown" flashes before the name arrives
  if (!stage) return isLoading ? null : <TextField>{t("unknown")}</TextField>;

  return <TextField>{stage.name}</TextField>;
};
